import * as Immutable from "immutable";
import { AbstractOperationMessage } from "./abstractOperationMessage"

export class AritcoConfMessage extends AbstractOperationMessage {
    
  protected readonly MESSAGE = "message";
  protected readonly SUCCESS = "success";

  get success(): boolean { return this.getInternalValue<boolean>(this.SUCCESS); }
  setSuccess(success: boolean): this { return this.setInternalValue(this.SUCCESS, success); }

  get message(): string { return this.getInternalValue<string>(this.MESSAGE); }
  setMessage(message: string): this { return this.setInternalValue(this.MESSAGE, message); }
}
